// extracted by mini-css-extract-plugin
export default {"ProductContainer":"Product_ProductContainer__Zcq-c"};